/*
 * @Description:
 * @Autor: yaoguorong
 * @Date: 2021-09-28 18:23:07
 * @LastEditors: yaoguorong
 * @LastEditTime: 2021-10-22 11:12:26
 */
import { NgModule } from '@angular/core';
import { RsNgCarouselModule } from "./components/rs-ng-carousel";
import { RsNgModalModule } from "./components/rs-ng-modal";
import { RsNgButtonLineModule } from './components/rs-ng-button-line';
import { RsNgStepsModule } from './components/rs-ng-steps';


const allModule = [
  RsNgCarouselModule,
  RsNgModalModule,
  RsNgButtonLineModule,
  RsNgStepsModule,
];

@NgModule({
  declarations: [],
  imports: [
    ...allModule
  ],
  exports: [
    ...allModule
  ]
})
export class RsNgCompositeModule { }
